import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { List, SendAndShare } from './';
import { VideoPages } from 'lib/const';
import { FolderShareModal } from '../components/FolderShareModal';
import { FolderShareOemModal } from '../components/FolderShareOemModal';

export const Main = () => {
  return (
    <Switch>
      <Route path='/home' component={List} exact={true} />
      <Route
        path={`/home/${VideoPages.SEND_AND_SHARE}/:videoId`}
        component={SendAndShare}
        exact={true}
      />
      <Route
        path={`/home/${VideoPages.FOLDER_SHARE}/:folderId/:page`}
        component={FolderShareModal}
        exact={true}
      />
      <Route
        path={`/home/${VideoPages.FOLDER_SHARE_OEM}/:folderId/:page`}
        component={FolderShareOemModal}
        exact={true}
      />
    </Switch>
  );
};
